(() => {
  function init(root) {
    root.querySelectorAll('[data-feedback-carousel]').forEach(widget => {
      if (widget.dataset.ready) return;
      widget.dataset.ready = 'true';
      const track = widget.querySelector('.nab-replies');
      const cards = [...track.querySelectorAll('.nab-reply')];
      const prev = widget.querySelector('[data-feedback-prev]');
      const next = widget.querySelector('[data-feedback-next]');
      const rtl = getComputedStyle(track).direction === 'rtl';
      if (rtl) { prev.textContent = '→'; next.textContent = '←'; }
      function offset(card) {
        const r = card.getBoundingClientRect(), t = track.getBoundingClientRect();
        return rtl ? r.right - t.right : r.left - t.left;
      }
      function update() {
        const direction = rtl ? -1 : 1;
        prev.disabled = offset(cards[0]) * direction >= -3;
        const last = cards.at(-1).getBoundingClientRect(), t = track.getBoundingClientRect();
        next.disabled = rtl ? last.left >= t.left - 3 : last.right <= t.right + 3;
      }
      function move(step) {
        let index = 0;
        cards.forEach((card,i) => { if (Math.abs(offset(card)) < Math.abs(offset(cards[index]))) index = i; });
        const target = cards[Math.max(0,Math.min(cards.length-1,index+step))];
        track.scrollBy({left:offset(target),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }
      prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
      track.addEventListener('scroll',update,{passive:true});
      track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move((e.key==='ArrowRight'?1:-1)*(rtl?-1:1));}});
      const observer=new ResizeObserver(update);observer.observe(track);update();
      widget.closest('.shopify-section')?.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
    });
  }
  init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();
